import {SvgIconData} from '@shared-web/components/core/svg_icon';

export const chevronRightIcon: SvgIconData = {
  viewBox: '8.5 6 7.5 12',
  element: <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />,
};
